var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { class: { "crosshair-pointer": _vm.enableZoom } },
    [
      _c("highcharts", {
        ref: "highcharts",
        attrs: { options: _vm.histogramOptions, callback: _vm.chartLoaded }
      })
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }